define('headerPhoneView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',   
  'plivoUtils',
  'imageUtils',
  'bootbox',
  'phoneParserView',
  'googlePhoneUtil',
  'template!headerPhoneView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  PlivoUtils,
  ImageUtils,
  Bootbox,
  PhoneParserView,
  GooglePhoneUtil,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'phone-view',  

    ui: {
      phone: '.phone',
      status: '.status',    
      numberPanel: '.number-panel',
      numberPanelPhoneNumber: '.number-panel .phone-number',
      phoneNumberButton: '.number-panel .numbers .item',
      phoneNumber: '.number-panel .phone-number',
      numberPanelCallButton: '.number-panel .call-button',
      validationPhoneMsg: '.number-panel .validate-phone-message',
      callingPhoneNumber: '.calling .phone-number .number',
      callingInIcon: '.calling .in-out .in',
      callingOutIcon: '.calling .in-out .out',
      callingHangupButton: '.calling .hangup',
      callingForwardButton: '.calling .forward',
      callingMutedButton: '.calling .muted',
      callingUnmutedButton: '.calling .unmuted',
      callingKeyboardButton: '.calling .keyboard-pannel',
      incomingCallPhoneNumber: '.incoming-call .phone-number .number',
      incomingCallRejectButton: '.incoming-call .reject',
      incomingCallIgnoreButton: '.incoming-call .ignore',
      incomingCallAnswerButton: '.incoming-call .answer'
    },

    events: {
      'click @ui.phone': 'onOpenNumberPanel',
      'click @ui.phoneNumberButton': 'onPhoneNumberClick',
      'paste @ui.phoneNumber': 'onPhoneNumberParse',
      'click @ui.numberPanelCallButton': 'onPhoneCall',
      'click @ui.callingHangupButton': 'onHangup',
      'click @ui.callingMutedButton': 'onUnmute',
      'click @ui.callingUnmutedButton': 'onMute',
      'click @ui.callingKeyboardButton': 'openCallingNumberPanel',
      'click @ui.callingForwardButton': 'onForward',
      'click @ui.incomingCallIgnoreButton': 'onIgnore',
      'click @ui.incomingCallRejectButton': 'onReject',
      'click @ui.incomingCallAnswerButton': 'onAnswer'
    },

    onShow: function () {   
       App.on('phone:update', _.bind(function (value) {      

        if(value.status === 'phone') {
          this.$el.attr('data-status', 'phone');
          this.closeNumberPanel();
        }
        
        if(value.status === 'calling') {
          this.$el.attr('data-status', 'calling');

          if(value.direction === 'in') {
            this.ui.callingInIcon.hide();    
            this.ui.callingOutIcon.show(); 
          }
  
          if(value.direction === 'out') {
            this.ui.callingInIcon.show();    
            this.ui.callingOutIcon.hide(); 
          }

          //this.ui.callingForwardButton.hide();
          this.closeNumberPanel();          

          this.ui.callingMutedButton.removeClass('activated');
          this.ui.callingUnmutedButton.addClass('activated');

          this.ui.callingPhoneNumber.html(value.phoneNumber);   
        }     
        
        if(value.status === 'incoming-call') {
          this.$el.attr('data-status', 'incoming-call');      
                    
          this.ui.incomingCallPhoneNumber.html(value.phoneNumber);   
        }
      }, this));    
      
      App.on('phone:calling:mute', _.bind(function (value) {    
        if(value) {
          this.ui.callingMutedButton.addClass('activated');
          this.ui.callingUnmutedButton.removeClass('activated');
        } else {
          this.ui.callingMutedButton.removeClass('activated');
          this.ui.callingUnmutedButton.addClass('activated');
        } 
      }, this));

      App.on('phone:numbering', _.bind(function (value) {
        var phoneNumber;
        if(value.country) {
          var PNF = GooglePhoneUtil.PhoneNumberFormat;
          var phoneUtil = GooglePhoneUtil.PhoneNumberUtil.getInstance();

          var country = 'BE';

          var gglPhone = phoneUtil.parse(value.phoneNumber, country);
          if (phoneUtil.isValidNumberForRegion(gglPhone, country)) {
            this.ui.validationPhoneMsg.hide();
          }
          phoneNumber = phoneUtil.format(gglPhone, PNF.E164);
        } else {
          phoneNumber = value.phoneNumber;
        }

        if(Settings.configValue('advancedMode') === true) {
          window.open('https://3cx.zaprinta.com/#/dialer?phone=' + encodeURIComponent(phoneNumber), '_blank');
        } else {
          this.ui.phoneNumber.val(phoneNumber);
          this.openNumberPanel();
        }
      }, this));

      $(document).on('click', _.bind(function(event) {
        //if(this.ui.phone && this.ui.phone.hasClass('activated')) {
          if (!event.target.closest('.number-panel') && !event.target.closest('.keyboard-pannel'))
            this.closeNumberPanel();
      }, this));

      $(document).on('keydown', _.bind(function(event) {
        if (event.keyCode === 27)
          if (!event.target.closest('.number-panel') && !event.target.closest('.keyboard-pannel'))
              this.closeNumberPanel();
      }, this));
    },
  
    onRender: function () { 
      this.$el.attr('data-status', 'phone');
      //this.ui.incomingCallPhoneNumber.html('sdfsdfsdf');   
    },

    onOpenNumberPanel: function(e) {
      e.stopPropagation();

      if(this.ui.phone.hasClass('activated')) {
        this.closeNumberPanel();
      } else {        
        this.openNumberPanel();      
      }     
    },

    openNumberPanel: function() {
      this.ui.validationPhoneMsg.hide();
      this.ui.numberPanelPhoneNumber.show();
      this.ui.numberPanelCallButton.addClass('activated');

      this.ui.numberPanel.addClass('activated');
      this.ui.phone.addClass('activated');
      this.ui.numberPanelPhoneNumber.select().focus();
    },

    openCallingNumberPanel: function() {
      this.ui.validationPhoneMsg.hide();
      this.ui.numberPanelPhoneNumber.hide();
      this.ui.numberPanelCallButton.removeClass('activated');

      this.ui.numberPanel.addClass('activated');  
    },

    closeNumberPanel: function() {
      if (this.ui.numberPanel && this.ui.numberPanel.removeClass) {
        this.ui.numberPanel.removeClass('activated');
      }
      if (this.ui.phone && this.ui.phone.removeClass) {
        this.ui.phone.removeClass('activated');
      }
    },

    onPhoneNumberClick: function (event) {        

      if(this.$el.attr('data-status') === 'phone')
        this.addPhoneNumber($(event.currentTarget).data('id'));
      
      if(this.$el.attr('data-status') === 'calling')
        this.dialPhoneNumberClick(event);      
    },

    onPhoneNumberParse: function(e) {
      e.preventDefault();
      var value = (e.originalEvent.clipboardData || window.clipboardData).getData('text');

      PhoneParserView.prototype.parse({
        number: value,
        onParsed: _.bind(function (value) {
          this.ui.phoneNumber.val(value);
        }, this)
      });
    },

    addPhoneNumber: function (value) {    
      var phoneNumber = this.ui.phoneNumber.val();     
      this.ui.phoneNumber.val(phoneNumber + value);
    },

    dialPhoneNumberClick: function(event) {      
      PlivoUtils.dtmf($(event.currentTarget).data('id'));
    },

    onPhoneCall: function() {      
      var regex = /^\+(?:[\d]*)$/;
      var value = this.ui.phoneNumber.val();
      value = value.replace(/\s/g, '');
      value = value.replaceAll('.', '');
      value = value.replaceAll('/', '');
      if (regex.test(value)) {
        this.ui.validationPhoneMsg.hide();
        PlivoUtils.callNumber(value);
      } else {
        this.ui.validationPhoneMsg.show();
      }
    },

    onHangup: function() {
      PlivoUtils.hangup();
    },

    onMute: function() {
      PlivoUtils.mute();
    },

    onUnmute: function() {
      PlivoUtils.unmute();
    },

    onIgnore: function() {
      PlivoUtils.ignore();
    },

    onReject: function() {
      PlivoUtils.reject();
    },

    onAnswer: function() {
      PlivoUtils.answer();
    },

    onForward: function () {
      PlivoUtils.findConnectedUsers().then(function(users) {
        var select = '<select class="forward-ddl">';
        for (var i = 0 ; i < users.length ; i++) {
          var user = users[i];
          select += '<option value="'+user.plivoUser+'">' + user.firstName + ' ' + user.lastName + '</option>';
        }
        select += '</select>';

        Bootbox.dialog({
          title: _.i18n('call.forward'),
          message: select,
          buttons: {
            success: {
              label: _.i18n('call.forward') ,
              className: 'btn-success',
              callback: function() {
                PlivoUtils.forwardCall(this.find('select').val());
              }
            }
          }
        });
      });
    }
  });
});

